<template>
  <div>
    <button class="btn btn-secondary" v-on:click="$emit('cancel')">
      Cancel
    </button>
    <div
      v-for="cat in budgetCategories"
      :key="cat.Application_Template_Response_Category_Id"
      class="mt-4"
    >
      <div class="row">
        <div class="col-auto px-0">
          <i
            class="material-icons pointer"
            v-bind:id="
              cat.Application_Template_Response_Category_Id + 'toggleIcon'
            "
            data-toggle="collapse"
            v-bind:href="
              '#category' + cat.Application_Template_Response_Category_Id
            "
            role="button"
            aria-expanded="false"
            v-on:click="
              $updateToggleIcon(
                '#' +
                  cat.Application_Template_Response_Category_Id +
                  'toggleIcon'
              )
            "
            >add</i
          >
        </div>
        <div class="col-auto pr-1">
          <h5 class="mb-0">
            {{ cat.Category }}
          </h5>
        </div>
        <div class="col-auto pl-0 pr-2 text-secondary">
          <h5>
            ({{
              cat.Application_Template_Responses.filter(r => !r.Is_Archived)
                .length
            }})
          </h5>
        </div>
        <div class="col-auto pl-0">
          <button
            v-bind:id="
              'summary' + cat.Application_Template_Response_Category_Id
            "
            class="btn text-left px-0 py-0 mb-1"
            style="height:26px;"
            data-toggle="popover"
            data-trigger="focus"
            v-on:click="
              $focusElement(
                'summary' + cat.Application_Template_Response_Category_Id
              )
            "
            data-placement="right"
            v-bind:data-content="cat.Summary"
          >
            <i class="material-icons-outlined pointer">info</i>
          </button>
        </div>
        <div class="col" />
      </div>
      <div style="height:1px; background-color:gray; width:100%;" />
      <div
        class="container collapse mt-2"
        v-bind:id="'category' + cat.Application_Template_Response_Category_Id"
      >
        <div
          v-for="(response, index) in cat.Application_Template_Responses.filter(
            r => !r.Is_Archived
          )"
          :key="response.Application_Template_Response_Id"
          class="row pb-4"
          v-bind:class="{ 'light-background': index % 2 === 1 }"
        >
          <div class="col-auto px-0">
            <button
              class="btn btn-sm btn-link px-0"
              v-on:click="useBudgetTemplate(response)"
            >
              Use
            </button>
          </div>
          <BudgetTemplateBody
            v-bind:Response="response"
            v-bind:Keywords="Keywords"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import BudgetTemplateBody from "@/components/ManageTemplates/BudgetTemplateBody";

export default {
  name: "BudgetTemplatePreview",
  components: {
    BudgetTemplateBody
  },
  props: {
    BudgetCategories: Array,
    Keywords: Array
  },
  data() {
    return {
      budgetCategories: this.BudgetCategories
    };
  },
  mounted() {
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
  },
  methods: {
    useBudgetTemplate(template) {
      this.$emit("useBudgetTemplate", template);
    }
  }
};
</script>
